const redirectTo = location => window && (window.location = location)

export default redirectTo
